import * as type from '../actions/types';

// TODO this should really be 4 different reducers
const initialState = {
  metrics: {
    region: '',
    changePercentage: { activeRestaurants: 0, dealsRedeemed: 0, netRevenue: 0, totalPartySize: 0 },
    current: {
      activeRestaurants: 0,
      dealsRedeemed: 0,
      netRevenue: 0,
      quarter: '',
      quarterEnd: '',
      quarterStart: '',
      totalPartySize: 0,
    },
    previous: {
      activeRestaurants: 0,
      dealsRedeemed: 0,
      netRevenue: 0,
      quarter: '',
      quarterEnd: '',
      quarterStart: '',
      totalPartySize: 0,
    },
  },
  milestones: {
    achieved: 0,
    milestones: [],
  },
  ratings: {
    reviews: [],
    summary: {
      averageRating: 0,
      numRatings: 0,
    },
  },
  restaurantData: {
    quarterData: {
      netRevenue: {
        quarterTotal: 0,
        percentageChangeFromLastQuarter: 0,
        monthly: [],
      },
      customers: {
        quarterTotal: 0,
        percentageChangeFromLastQuarter: 0,
        monthly: [],
      },
      averageOrderValue: {
        quarterTotal: 0,
        percentageChangeFromLastQuarter: 0,
        monthly: [],
      },
      impressions: {
        quarterTotal: 0,
        percentageChangeFromLastQuarter: 0,
        monthly: [],
        regionalAverage: 0,
      },
      profileViews: {
        quarterTotal: 0,
        regionalAverage: 0,
      },
      transactions: {
        quarterTotal: 0,
        regionalAverage: 0,
      },
      redemptions: {
        quarterTotal: 0,
        regionalAverage: 0,
      },
    },
  },
  pendingRestaurantData: true,
  pendingMetrics: true,
  pendingMilestones: true,
  pendingRatings: true,
  error: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_REGIONAL_METRICS_PENDING:
      return {
        ...state,
        pendingMetrics: true,
        error: '',
      };
    case type.FETCH_REGIONAL_METRICS_SUCCESS:
      return {
        ...state,
        metrics: action.payload?.data ?? {},
        pendingMetrics: false,
        success: true,
      };
    case type.FETCH_REGIONAL_METRICS_FAILURE:
      return {
        ...state,
        error: action.payload,
        pendingMetrics: false,
      };

    case type.FETCH_QUARTERLY_RESTAURANT_DATA_PENDING:
      return {
        ...state,
        pendingRestaurantData: true,
        error: '',
      };
    case type.FETCH_QUARTERLY_RESTAURANT_DATA_SUCCESS:
      return {
        ...state,
        restaurantData: action.payload?.data ?? {},
        pendingRestaurantData: false,
        success: true,
      };
    case type.FETCH_QUARTERLY_RESTAURANT_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        pendingRestaurantData: false,
      };

    case type.FETCH_QUARTERLY_MILESTONES_PENDING:
      return {
        ...state,
        pendingMilestones: true,
        error: '',
      };
    case type.FETCH_QUARTERLY_MILESTONES_SUCCESS:
      return {
        ...state,
        milestones: action.payload?.data ?? {},
        pendingMilestones: false,
        success: true,
      };
    case type.FETCH_QUARTERLY_MILESTONES_FAILURE:
      return {
        ...state,
        error: action.payload,
        pendingMilestones: false,
      };

    case type.FETCH_QUARTERLY_RATINGS_PENDING:
      return {
        ...state,
        pendingRatings: true,
        error: '',
      };
    case type.FETCH_QUARTERLY_RATINGS_SUCCESS:
      return {
        ...state,
        ratings: action.payload?.data ?? {},
        pendingRatings: false,
        success: true,
      };
    case type.FETCH_QUARTERLY_RATINGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        pendingRatings: false,
      };

    default:
      return state;
  }
};
